import { useIsYellowMemberRightsModalShow } from '@/utils/fetchers/base'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'
import Modal from './Modal'

export interface YellowMemberRightsModalProps extends HTMLAttributes<HTMLDivElement> {}

export default function YellowMemberRightsModal({ ...props }: YellowMemberRightsModalProps) {
	const [isShow, setIsShow] = useIsYellowMemberRightsModalShow()

	return (
		<Modal
			isShow={isShow}
			onClose={() => setIsShow(false)}
			css={css`
				.jk-modal-container {
					padding: 0;
					background-color: transparent;
					max-width: unset;
					max-height: unset;
					width: fit-content;

					.jk-modal-main {
						display: block;
						overflow: unset;
					}
				}
			`}
		>
			<img
				src="https://cdnv2.ruguoapp.com/FlHEfqaOMiWvKDIr2WyK-c9XFqNX.png"
				css={css`
					max-width: 95vw;
					max-height: 95vh;
					border-radius: 20px;
				`}
			/>
		</Modal>
	)
}
